import React from "react";
import { Dialog } from "../../ui/Dialog/Dialog";
import { AlertCircle } from "lucide-react";

/**
 * Reusable Disclaimer Modal Component
 * Displays the application disclaimer in a modal dialog
 */
export const DisclaimerModal = ({ isOpen, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={
        <div className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5 text-amber-600" />
          <span>Application Disclaimer</span>
        </div>
      }
      maxWidth="5xl"
    >
      <div className="space-y-4 text-sm text-gray-700 leading-relaxed max-h-[60vh] overflow-y-auto">
        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded">
          <p className="font-semibold text-amber-900 mb-2">Important Notice</p>
          <p className="text-amber-800">
            Please read this disclaimer carefully before using the conRIO
            application.
          </p>
        </div>

        <div className="space-y-3">
          <p>
            This application is intended to support customers in identifying
            potential impacts of SAP DM release changes based on the information
            and configuration provided by the user.
          </p>

          <p>
            The accuracy and completeness of the results depend critically on
            the correct preselection and configuration of the relevant SAP DM
            services by the customer. If incorrect, incomplete, or outdated
            information is provided, the analysis may be inaccurate or
            misleading.
          </p>

          <p>
            While the application has been developed and is operated with due
            care and to the best of our knowledge and belief, it is provided on
            an <strong>"as is"</strong> basis. No warranty, express or implied,
            is given regarding the accuracy, completeness, reliability, or
            suitability of the results for a particular purpose.
          </p>

          <p>
            Due to the inherent complexity of software systems and the nature of
            digital applications, errors, limitations, or unexpected behavior
            may occur. The use of this application and reliance on its results
            are at the customer's own risk.
          </p>

          <p>
            To the maximum extent permitted by applicable EU law, the provider
            shall not be liable for any direct or indirect damages, losses, or
            consequences arising from the use of, or inability to use, this
            application, including but not limited to incorrect impact
            assessments, system changes, or business decisions based on the
            results.
          </p>

          <p className="font-medium text-gray-900">
            The application does not replace a detailed technical analysis,
            professional judgment, or manual verification by qualified
            personnel.
          </p>
        </div>

        <div className="pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-[#0854a0] text-white rounded-md hover:bg-[#064080] transition-colors font-medium"
          >
            I Understand
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DisclaimerModal;
